import { render, staticRenderFns } from "./UpTime.vue?vue&type=template&id=0955c296&"
import script from "./UpTime.vue?vue&type=script&lang=js&"
export * from "./UpTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0955c296')) {
      api.createRecord('0955c296', component.options)
    } else {
      api.reload('0955c296', component.options)
    }
    module.hot.accept("./UpTime.vue?vue&type=template&id=0955c296&", function () {
      api.rerender('0955c296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/UpTime.vue"
export default component.exports